document.addEventListener('DOMContentLoaded', () => {
  const filterButtons = document.querySelectorAll<HTMLButtonElement>('.filter-button');
  const memberItems = document.querySelectorAll<HTMLDivElement>('.member-item');

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const letter = button.getAttribute('data-letter');

      // Mostrar todos los miembros si se selecciona "TODOS"
      if (letter === 'all') {
        memberItems.forEach((item) => {
          item.classList.remove('hidden');
        });
      } else {
        // Mostrar solo los miembros que coincidan con la letra seleccionada
        memberItems.forEach((item) => {
          if (item.getAttribute('data-letter') === letter) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        });
      }

      // Resaltar el botón activo
      filterButtons.forEach((btn) => btn.classList.remove('bg-dci-primary', 'text-white'));
      button.classList.add('bg-dci-primary', 'text-white');
    });
  });
});